import { render } from "./TheDebugger.vue?vue&type=template&id=fc9e46b4&scoped=true"
import script from "./TheDebugger.vue?vue&type=script&lang=js"
export * from "./TheDebugger.vue?vue&type=script&lang=js"

import "./TheDebugger.vue?vue&type=style&index=0&id=fc9e46b4&scoped=true&lang=css"

import exportComponent from "/home/wsl-ubuntu/work-repos/ats-201-build-a-planet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc9e46b4"]])

export default __exports__